import { GenericCrudPage } from '@/components/GenericCrudPage';
import { loginHistoryConfig } from '@/pages/configs';

export default function LoginHistoryPage() {
  return <GenericCrudPage config={loginHistoryConfig} />;
}
